export const ApiQueryKey = {
	admins: 'admins',

	creatorProductModules: 'creator-product-modules',
	projects: 'projects',

	productModuleCollections: 'product-module-collections',
	productModules: 'product-modules',
	productModulesCategories: 'product-module-categories',
	landscapeModules: 'landscape-modules',
	playgorundFillings: 'playground-fillings',
	assets: 'assets',
	roles: 'roles',
	merchants: 'merchants',
	content: 'content',

	stores: 'stores',
	integrations: 'integrations',
} as const;

export type ApiQueryKey = (typeof ApiQueryKey)[keyof typeof ApiQueryKey];
